module.exports = "/assets/data/6a2fa9e74f48ebc5487e12c182fcd36e-SE17.data.json";